import { Routes, Route } from "react-router-dom";
import Home from "../src/pages/Inicio";
import Services from "../src/pages/Servicios";
import Plans from "../src/pages/Planos";
import About from "../src/pages/Nosotros";
import Contact from "../src/pages/Contacto";
import Layout from "./Layout";
import ServiceDetail from "./components/ServiceDetail";
import ServiciosTopografiaPage from "./pages/servicios-topografia/ServiciosTopografiaPage";
import ServicioDetalle from "./pages/servicios-topografia/ServicioDetalle";
import AuthMaintenance from "./pages/AuthMaintenance"
import Terms from "./pages/Terms";
import FAQ from "./pages/FAQ";
import PlanDetail from "./components/plans/PlanDetail";
import  plansData from "./data/plansData";
import PaymentInfo from "./pages/PaymentInfo";
import PlanoFree from "./pages/PlanoFree";
import DetallePlano from "./pages/DetallePlanoFree";
import Branding from "./pages/Branding";


const AppRouter = () => {
  return (
    <Layout>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/planos" element={<Plans />} />
        <Route path="/planos/:id" element={<PlanDetail plans={plansData} />} />

        <Route path="/nosotros" element={<About />} />
        <Route path="/contacto" element={<Contact />} />
        <Route path="/servicios" element={<Services />} />

        <Route path="/planos-gratis" element={<PlanoFree />} />
        <Route path="/planos-gratis/:slug" element={<DetallePlano />} />
        <Route path="/planix-branding" element={<Branding />} />

        <Route path="/servicios/topografia" element={<ServiciosTopografiaPage />} />
        <Route path="/servicios/topografia/:slug" element={<ServicioDetalle />} />

        <Route path="/servicios/:slug" element={<ServiceDetail />} />

        <Route path="/terminos-y-condiciones" element={<Terms />} />
        <Route path="/preguntas-frecuentes" element={<FAQ />} />
        <Route path="/metodos-de-pago" element={<PaymentInfo />} />

        <Route path="/login" element={<AuthMaintenance type="login" />} />
        <Route path="/registro" element={<AuthMaintenance type="registro" />} />

        <Route path="*" element={<Home />} />
      </Routes>
    </Layout>
  );
};

export default AppRouter;